// extracted by mini-css-extract-plugin
module.exports = {"root":"app-menu_root__3Wfdm","category":"app-menu_category__3Rop6"};